import { Injectable } from '@angular/core';

import { BetBuilderConfig } from '@frontend/sports/common/client-config-data-access';

import { BaseBetslipGroupPick } from '../../../../../../core/picks/betslip-group-pick';
import { IBetslip } from '../../../../../bet-generation/models';
import { GroupMaxSelectionsError } from '../../../../errors/general/group-pick-error';
import { ComboBetValidationContext } from '../../../../models/models';
import { IComboBetBetslipValidator } from '../validators';

@Injectable()
export class MaxSelectionsGroupPickComboBetValidator implements IComboBetBetslipValidator<GroupMaxSelectionsError> {
    constructor(private betBuilderConfig: BetBuilderConfig) {}

    validate(_: IBetslip, context: ComboBetValidationContext): GroupMaxSelectionsError[] {
        const hasInvalidBetBuilderPicks = context.typeContext.selectedPicks.some(
            (p) => BaseBetslipGroupPick.isPick(p) && p.getLegs().length > this.betBuilderConfig.maxSelectionsPerPick,
        );

        return hasInvalidBetBuilderPicks ? [new GroupMaxSelectionsError()] : [];
    }
}
